import { render, staticRenderFns } from "./SearchTag.vue?vue&type=template&id=0f2b8ff4&scoped=true"
import script from "./SearchTag.vue?vue&type=script&lang=js"
export * from "./SearchTag.vue?vue&type=script&lang=js"
import style0 from "./SearchTag.vue?vue&type=style&index=0&id=0f2b8ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2b8ff4",
  null
  
)

export default component.exports